export default "__VITE_ASSET__BXtZsX72__"